/** @format */

import org from './org';
import role from './role';
import group from './group';
import position from './position';

export default {
	orgTypeEven: org,
	roleTypeEven: role,
	groupTypeEven: group,
	positionTypeEven: position,
};
